import React from "react";
import { Link } from "react-router-dom";
import Transport from "@mui/icons-material/EmojiTransportationOutlined";

const Navbar = () => {
  return (
    <nav>
      <div className="logo">
        <Transport sx={{ color: "white", fontSize: 50 }} />
        <Link to={"/"}>
          {" "}
          <h3>AutoStructure</h3>
        </Link>
      </div>
      <div className="a-links">
        <Link to={"/"}>Asosiy</Link>
        <Link to={"/qollanma"}>Qo'llanma</Link>
        <Link to={"/manbalar"}>Manbalar</Link>
        <Link to={"/boglanish"}>Boglanish</Link>
      </div>
    </nav>
  );
};

export default Navbar;
